var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"collapse-title",attrs:{"type":"text","icon":_vm.display === true ? 'el-icon-arrow-down' : 'el-icon-arrow-right'},on:{"click":_vm.clickAction}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }